<template>
  <div>
    <v-btn
      :disabled="disabled"
      @click.stop="setDialog(true)"
      :alt-text="`Delete ${entityType}`"
      color="primary"
      outlined
      small
      :title="`Delete ${entityType}`"
      >Delete
    </v-btn>

    <v-dialog v-model="dialog" max-width="400" persistent>
      <delete-confirmation
        :entityType="entityType"
        :entityId="entityId"
        @setDialog="setDialog"
      ></delete-confirmation>
    </v-dialog>
  </div>
</template>

<script>
import DeleteConfirmation from "@/components/DeleteConfirmation";

export default {
  components: { DeleteConfirmation },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    async setDialog(val) {
      if (val === true) {
        try {
          await this.$store.dispatch(`${this.entityType}/get`, this.entityId);
        } catch (e) {
          this.$notifyError({
            message: "Could not get item.",
          });
        }
      }
      this.dialog = val;
    },
  },
  props: ["disabled", "entityType", "entityId"],
};
</script>
